function descriptorManagementController($scope, $uibModal, PackageService, toasterService, userService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.refreshDescriptorsList();
    ctrl.hasEditDescriptors = userService.hasEditDescriptors();
  };

  ctrl.selectModule = module => {
    ctrl.selectedModule = module;
  };

  ctrl.openNewDescriptorModal = () => {
    let modalInstance = $uibModal.open({
      component: 'descriptorForm',
      backdrop: 'static',
      resolve: {
        descriptors: function() {
          return ctrl.allDescriptors;
        },
        moduleList: function() {
          return ctrl.moduleList;
        },
      },
    });

    modalInstance.result.then(
      newDescriptor => {
        // User pressed 'Yes' in the modal.
        ctrl.saveNewDescriptor(newDescriptor);
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.saveNewDescriptor = newDescriptor => {
    const foundDescriptor = ctrl.allDescriptors.find(item => item.type === newDescriptor.type);
    if (foundDescriptor) {
      if (newDescriptor.sw_revision) {
        if (foundDescriptor.sw_revision.some(e => e.version_number === newDescriptor.sw_revision)) {
          toasterService.error('toaster.descriptors-creation-event', 'toaster.descriptors-duplicate-event');
          return;
        }
      } else {
        if (foundDescriptor.hw_revision.some(e => e.version_number === newDescriptor.hw_revision)) {
          toasterService.error('toaster.descriptors-creation-event', 'toaster.descriptors-duplicate-event');
          return;
        }
      }
    }
    PackageService.addDescriptor(newDescriptor).then(
      function(response) {
        if (response.errorType) {
          toasterService.error('toaster.descriptors-creation-event', ctrl.createDescriptorErrorMessage(response.errorType));
          return;
        }
        toasterService.success('toaster.descriptors-creation-event', 'toaster.descriptors-new-descriptor-successful');
        ctrl.refreshDescriptorsList();
      },
    );
  };

  ctrl.saveDescriptor = event => {
    PackageService.editDescriptor(event.descriptor.status, event.descriptor.id).then(
      function(response) {
        if (response.errorType) {
          toasterService.error('toaster.descriptors-edit-event', ctrl.createDescriptorErrorMessage(response.errorType));
          return;
        }
        toasterService.success('toaster.descriptors-edit-event', 'toaster.descriptors-edit-descriptor-successful');
        ctrl.refreshDescriptorsList();
      },
    );
  };

  ctrl.createDescriptorErrorMessage = errorText => {
    let errorMessage = errorText;
    errorMessage = errorMessage.replaceAll('_', ' ').toLowerCase();
    errorMessage = errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1);
    errorMessage = errorMessage.concat('!');
    return errorMessage;
  }

  ctrl.removeDescriptor = event => {
    PackageService.deleteDescriptor(event.descriptor.id).then(
      function(response) {
        toasterService.success('toaster.descriptors-remove-event', 'toaster.descriptors-remove-descriptor-successful');
        ctrl.refreshDescriptorsList();
      },
      function(e) {
        toasterService.error('toaster.descriptors-remove-event', 'toaster.descriptors-remove-descriptor-failure');
        console.log(e);
      }
    );
  };

  ctrl.refreshDescriptorsList = async () => {
    try {
      ctrl.allDescriptors = await PackageService.getAllDescriptors();
      ctrl.dtsDescriptors = [];
      ctrl.pisDescriptors = [];
      ctrl.cctvDescriptors = [];
      ctrl.tractionDescriptors = [];
      ctrl.trainborneDescriptors = [];
      if (ctrl.allDescriptors.length === 0) {
        ctrl.accordionStatus = [];
        ctrl.selectedModule = null;
      }
      _.each(ctrl.allDescriptors, descriptor => {
        if (ctrl.selectedModule && (descriptor.sw_revision.length > 0 || descriptor.hw_revision.length > 0)) {
          if (descriptor.type === ctrl.selectedModule.type) {
            ctrl.selectModule(descriptor);
          } 
        } else {
          ctrl.selectedModule = null;
        }
        const foundDescriptor = ctrl.moduleList.find(item => item.module === descriptor.type);
        if (!foundDescriptor) return;
        if (foundDescriptor.family === 'DTS') {
          if (!ctrl.dtsDescriptors.some(e => e.type === descriptor.type)) {
            ctrl.dtsDescriptors.push(descriptor);
          }
        } else if (foundDescriptor.family === 'PIS') {
          if (!ctrl.pisDescriptors.some(e => e.type === descriptor.type)) {
            ctrl.pisDescriptors.push(descriptor);
          }
        } else if (foundDescriptor.family === 'Trainborne') {
          if (!ctrl.trainborneDescriptors.some(e => e.type === descriptor.type)) {
            ctrl.trainborneDescriptors.push(descriptor);
          }
        } else if (foundDescriptor.family === 'CCTV') {
          if (!ctrl.cctvDescriptors.some(e => e.type === descriptor.type)) {
            ctrl.cctvDescriptors.push(descriptor);
          }
        } else if (foundDescriptor.family === 'Traction system') {
          if (!ctrl.tractionDescriptors.some(e => e.type === descriptor.type)) {
            ctrl.tractionDescriptors.push(descriptor);
          }
        }
      });
    }
    catch (err) {
      console.error(`Error fetching descriptors: ${err}`);
    }
  };
}

angular
  .module('package-management.module')
  .controller('descriptorManagementController', descriptorManagementController);
